<template>
  <div id="NotDel">
    <Head @isLoginOpen="isLoginOpen" />
    <Login @isLoginOpen="isLoginOpen" v-if="isLogin" />
    <div class="main" v-if="$route.query.id==0">
      <p class="title">{{list[id][j].Title}}</p>
      <p class="date">发布时间：{{list[id][j].Date}} 来源：网上投稿</p>
      <img :src="list[id][j].src" alt />
      <p class="container">{{list[id][j].content}}</p>
      <!-- <p v-for="(item,i) in list[xiabiao]" :key="i">{{item}}</p> -->
      <!-- <div>
        <p>网站声明：凡本网转载自其它媒体的各类新闻，转载目的在于传递更多信息，并不代表本网赞同</p>
        <p>其观点和对其真实性负责。</p>
      </div>-->
    </div>
    <div class="main" v-else>
      <p class="title">{{list2[id][j].Title}}</p>
      <img :src="list2[id][j].src" alt="">
    </div>
    <Foot />
  </div>
</template>

<script>
import Head from "../components/Head";
import Foot from "../components/Foot";
import Login from "../components/Login";
export default {
  data() {
    return {
      isLogin: false,
      id: "",
      j: "",
      // list: [
      //   {
      //     title: "关于拟认定煤炭行业工程研究中心名单的公示",
      //     time: "发布时间:2020-03-17 08:32:00	来源:国家煤炭工业网",
      //     duan1:
      //       "根据《煤炭行业工程研究中心管理办法》规定，经自愿申请、形式审查、现场评审和专家评审环节，确定了拟认定的煤炭行业工程研究中心名单。现予以公示。",
      //     duan2:
      //       "公示期为2020年3月17日至3月23日。公示期间如有异议，请以书面形式正式提出，并提供必要的证明材料。反映情况要客观真实，以单位名义反映情况的材料需加盖单位公章，以个人名义反映情况的材料应提供有效的联系方式和地址。超出公示期限的不予受理。",
      //     duan3: "联 系 人：中国煤炭工业协会科技发展部 高杨",
      //     duan4: "联系电话：010-64464146、13488766167",
      //     duan5: "电子邮箱：kejiguihua@163.com"
      //     // date: "2020年03月17日"
      //   },
      //   {
      //     title: "中国煤炭学会关于征集抗击新冠肺炎典型事迹和典型人物的通知",
      //     time: "发布时间:2020-02-18 10:48:22	来源:中国煤炭学会",
      //     duan1:
      //       "为深入贯彻落实习近平总书记关于新冠肺炎的重要指示精神，进一步凝聚科技工作者力量，坚决打赢疫情防控阻击战，按照中国科协《关于征集全国学会党组织、党员科技工作者抗击新冠肺炎典型事迹和典型人物的通知》要求，现向各单位征集抗击新冠肺炎典型事迹和典型人物，有关事项通知如下。",
      //     duan2: "一、征集内容",
      //     duan3:
      //       "（一）各单位及各单位党组织在抗击新冠肺炎疫情中开展的重点工作和相关人物事迹；",
      //     duan4:
      //       "（二）在抗击新冠肺炎疫情中开展的应急科普、科技支援、引导服务群众中涌现出的先进事迹，以及不畏艰险、无私奉献的典型人物。",
      //     duan5: "二、注意事项",
      //     duan6:
      //       "（一）征集内容以文字、图片材料为主，字数不限。如有相关视频、网址链接请一并发送。",
      //     duan7:
      //       "（二）材料报送无时间限制，新闻稿件请第一时间及时报送。为及时交流典型事迹和典型人物，扩大宣传力度和影响力，学会党委将通过学会网站、微信平台等形式进行宣传报道，并向中国科协及相关媒体推荐。",
      //     duan8: "（三）报送邮箱：mtxh@chinacs.org.cn。"
      //     // date: "2020年02月18日"
      //   },
      //   {
      //     title: "2019-2021年度中国科协青年托举工程被托举人评审结果公示",
      //     time: "发布时间:2020-01-07 11:37:38	来源:国家煤炭工业网",
      //     duan1:
      //       '根据《中国科协青年人才托举工程管理办法》、《中国煤炭学会青年人才托举工程管理办法》和《中国科协青年人才托举工程实施细则》有关要求，经过前期申报、资格审查，于2020年1月5日,通过申报人答辩、专家组评审、投票，以下10名同志入选“2019-2021年度中国科协青年托举工程被托举人"，现将结果进行公示。公示期1月6日至1月10日，凡对上述结果有异议者，请在公示期内以书面形式实名提出，不接受匿名举报。同时请申报人所在单位人事处同期公示，公示情况以书面形式反馈到中国煤炭学会，联系人：王永基 010-84263451、18811138807'

      //     // date: "2020年01月17日"
      //   },
      //   {
      //     title: "协会拟提名2020年度国家科学技术奖项目公示",
      //     time: "发布时间:2020-01-07 11:37:38	来源:国家煤炭工业网",
      //     duan1:
      //       "为深入贯彻落实习近平总书记关于新冠肺炎的重要指示精神，进一步凝聚科技工作者力量，坚决打赢疫情防控阻击战，按照中国科协《关于征集全国学会党组织、党员科技工作者抗击新冠肺炎典型事迹和典型人物的通知》要求，现向各单位征集抗击新冠肺炎典型事迹和典型人物，有关事项通知如下。",
      //     duan2: "一、征集内容",
      //     duan3:
      //       "（一）各单位及各单位党组织在抗击新冠肺炎疫情中开展的重点工作和相关人物事迹；",
      //     duan4:
      //       "（二）在抗击新冠肺炎疫情中开展的应急科普、科技支援、引导服务群众中涌现出的先进事迹，以及不畏艰险、无私奉献的典型人物。",
      //     duan5: "二、注意事项",
      //     duan6:
      //       "（一）征集内容以文字、图片材料为主，字数不限。如有相关视频、网址链接请一并发送。",
      //     duan7:
      //       "（二）材料报送无时间限制，新闻稿件请第一时间及时报送。为及时交流典型事迹和典型人物，扩大宣传力度和影响力，学会党委将通过学会网站、微信平台等形式进行宣传报道，并向中国科协及相关媒体推荐。",
      //     duan8: "（三）报送邮箱：mtxh@chinacs.org.cn。"
      //     // date: "2019年12月10日"
      //   },
      //   {
      //     title: "中国煤炭工业协会关于2019年煤炭行业企业信用评价结果的公示",
      //     time: "发布时间:2020-01-07 11:37:38	来源:国家煤炭工业网",
      //     duan1:
      //       "为深入贯彻落实习近平总书记关于新冠肺炎的重要指示精神，进一步凝聚科技工作者力量，坚决打赢疫情防控阻击战，按照中国科协《关于征集全国学会党组织、党员科技工作者抗击新冠肺炎典型事迹和典型人物的通知》要求，现向各单位征集抗击新冠肺炎典型事迹和典型人物，有关事项通知如下。",
      //     duan2: "一、征集内容",
      //     duan3:
      //       "（一）各单位及各单位党组织在抗击新冠肺炎疫情中开展的重点工作和相关人物事迹；",
      //     duan4:
      //       "（二）在抗击新冠肺炎疫情中开展的应急科普、科技支援、引导服务群众中涌现出的先进事迹，以及不畏艰险、无私奉献的典型人物。",
      //     duan5: "二、注意事项",
      //     duan6:
      //       "（一）征集内容以文字、图片材料为主，字数不限。如有相关视频、网址链接请一并发送。",
      //     duan7:
      //       "（二）材料报送无时间限制，新闻稿件请第一时间及时报送。为及时交流典型事迹和典型人物，扩大宣传力度和影响力，学会党委将通过学会网站、微信平台等形式进行宣传报道，并向中国科协及相关媒体推荐。",
      //     duan8: "（三）报送邮箱：mtxh@chinacs.org.cn。"
      //     // date: "2019年11月28日"
      //   },
      //   {
      //     title: "关于召开中国煤炭经济研究会第八次会员代表大会的通知",
      //     time: "发布时间:2020-01-07 11:37:38	来源:国家煤炭工业网",
      //     duan1:
      //       "为深入贯彻落实习近平总书记关于新冠肺炎的重要指示精神，进一步凝聚科技工作者力量，坚决打赢疫情防控阻击战，按照中国科协《关于征集全国学会党组织、党员科技工作者抗击新冠肺炎典型事迹和典型人物的通知》要求，现向各单位征集抗击新冠肺炎典型事迹和典型人物，有关事项通知如下。",
      //     duan2: "一、征集内容",
      //     duan3:
      //       "（一）各单位及各单位党组织在抗击新冠肺炎疫情中开展的重点工作和相关人物事迹；",
      //     duan4:
      //       "（二）在抗击新冠肺炎疫情中开展的应急科普、科技支援、引导服务群众中涌现出的先进事迹，以及不畏艰险、无私奉献的典型人物。",
      //     duan5: "二、注意事项",
      //     duan6:
      //       "（一）征集内容以文字、图片材料为主，字数不限。如有相关视频、网址链接请一并发送。",
      //     duan7:
      //       "（二）材料报送无时间限制，新闻稿件请第一时间及时报送。为及时交流典型事迹和典型人物，扩大宣传力度和影响力，学会党委将通过学会网站、微信平台等形式进行宣传报道，并向中国科协及相关媒体推荐。",
      //     duan8: "（三）报送邮箱：mtxh@chinacs.org.cn。"
      //     // date: "2019年11月28日"
      //   },
      //   {
      //     title: "2019-2021年度中国科协青年托举工程被托举人评审结果公示",
      //     time: "发布时间:2020-01-07 11:37:38	来源:国家煤炭工业网",
      //     duan1:
      //       "为深入贯彻落实习近平总书记关于新冠肺炎的重要指示精神，进一步凝聚科技工作者力量，坚决打赢疫情防控阻击战，按照中国科协《关于征集全国学会党组织、党员科技工作者抗击新冠肺炎典型事迹和典型人物的通知》要求，现向各单位征集抗击新冠肺炎典型事迹和典型人物，有关事项通知如下。",
      //     duan2: "一、征集内容",
      //     duan3:
      //       "（一）各单位及各单位党组织在抗击新冠肺炎疫情中开展的重点工作和相关人物事迹；",
      //     duan4:
      //       "（二）在抗击新冠肺炎疫情中开展的应急科普、科技支援、引导服务群众中涌现出的先进事迹，以及不畏艰险、无私奉献的典型人物。",
      //     duan5: "二、注意事项",
      //     duan6:
      //       "（一）征集内容以文字、图片材料为主，字数不限。如有相关视频、网址链接请一并发送。",
      //     duan7:
      //       "（二）材料报送无时间限制，新闻稿件请第一时间及时报送。为及时交流典型事迹和典型人物，扩大宣传力度和影响力，学会党委将通过学会网站、微信平台等形式进行宣传报道，并向中国科协及相关媒体推荐。",
      //     duan8: "（三）报送邮箱：mtxh@chinacs.org.cn。"
      //     // date: "2019年10月17日"
      //   }
      // ]
      list: [
        [
          {
            Title: "山能淄矿亭南煤业：暖心苹果免费领",
            src: require("../assets/Index/xinwen1.jpg"),
            content:
              "3月22日，山东能源淄矿集团亭南煤业公司工会为缓解长期封闭管理下的职工心理压力，满足职工合理生活诉求，购买了18吨新鲜苹果免费发放给员工。图为结算中心员工王抱龙领取苹果。",
            Date: "2020-03-25"
          },
          {
            Title: "山能龙矿梁家煤矿开展全员大练兵",
            src: require("../assets/Index/xinwen2.jpg"),
            content:
              "为全面提升职工队伍整体素质，3月下旬，山东能源龙矿集团梁家煤矿全面开展“强‘三基’、提技能”全员大练兵活动，对41项竞赛项目逐一细化分解，实行“清单化+项目化+责任化”管理模式，积极为广大职工提升技能、切磋技艺、展现风采搭建平台。图为电焊工岗位练兵。",
            Date: "2020-03-25"
          },
          {
            Title: "抓时间、抢进度，擂响项目推进战鼓",
            src: require("../assets/Index/xinwen3.jpg"),
            content:
              "为全面提升职工队伍整体素质，3月下旬，山东能源龙矿集团梁家煤矿全面开展“强‘三基’、提技能”全员大练兵活动，对41项竞赛项目逐一细化分解，实行“清单化+项目化+责任化”管理模式，积极为广大职工提升技能、切磋技艺、展现风采搭建平台。图为电焊工岗位练兵。山能置业德圣公司巨山花园项目以奔跑的干劲、决战的姿态、冲刺的速度，按照“防疫不松劲，复工加把劲”的原则，在做好疫情防控工作的前提下吹响了复工复产的号角，防疫生产“两手抓”，奋力夺取“双胜利”，在二期施工现场掀起了一阵阵施工热潮。图为德圣公司巨山花园项目二期施工现场。",
            Date: "2020-03-25"
          },
          {
            Title: "关键时刻显担当 山能矿工逆行火场驰援地方",
            src: require("../assets/Index/xinwen4.jpg"),
            content:
              "为全面提升职工队伍整体素质，3月下旬，山东能源龙矿集团梁家煤矿全面开展“强‘三基’、提技能”全员大练兵活动，对41项竞赛项目逐一细化分解，实行“清单化+项目化+3月19日下午16时，山东能源龙矿集团大恒煤业突然接到山西省朔州市平鲁区下面高乡政府的救援通知，位于矿区下面高乡白家梁村旧址突发山火，请求援助。该煤业公司立刻调动了7辆车辆，60余名矿工奔赴火场。经过奋战，晚上20时，山火成功被扑灭。该公司关键时刻的紧急驰援，得到了驻地政府和百姓的高度赞扬，彰显了国企的责任担当。",
            Date: "2020-03-20"
          },
          {
            Title: "山能龙矿梁家煤矿充填试采钻孔项目顺利开工",
            src: require("../assets/Index/xinwen5.jpg"),
            content:
              "3月17日上午，随着钻机的一阵阵轰鸣声，山东能源龙矿集团梁家煤矿充填试采地面系统钻孔项目顺利开工。启动标志着，该矿充填试采工程地面系统建设进入实质性施工阶段，为矿井找煤扩量、延续生存迈出了关键一步。",
            Date: "2020-03-18"
          },
          {
            Title: "智能测温提升职工入井速度",
            src: require("../assets/Index/xinwen6.jpg"),
            content:
              "近日，山东能源淄矿集团新河矿业公司副井口投入使用的红外线测温仪，成为严把井口测温关的致胜“法宝”。据了解，该仪器能够实时精准测量下井人员体温，实现人员不停留、不漏检，大大提升了职工入井速度。图为工作人员查看入井人员信息。",
            Date: "2020-03-17"
          }
        ],
        [
          {
            Title: "“点对点”体检电网确保“零接触”",
            src: require("../assets/Index/xinwen7.jpg"),
            content:
              "3月中旬，针对一年一度的电网春检工作，山东能源龙矿集团供电部实行“点对点”式检修工作制度，并在每个职工作业地点设置隔离护栏，旨在确保“零接触、零交叉、零感染”。此外，还制定了重要用户应急处置预案，以确保检修、保供万无一失。图为：3月13日，龙矿供电部检修人员正在“把脉”设备。",
            Date: "2020-03-16"
          },
          {
            Title: "为矿山添一抹绿色",
            src: require("../assets/Index/xinwen8.jpg"),
            content:
              "3月12日，山能淄矿邵寨煤业公司开展了“呵护一片绿色”义务植树护绿活动，该公司团委组织广大团员青年对矿区宿舍楼前的花草、树木进行了浇水培土。活动中，他们共浇树30余棵，补种各类绿植22棵。",
            Date: "2020-03-13"
          },
          {
            Title: "山能临矿株柏煤矿：开展“战疫情，绿动青春”志愿植树活动",
            src: require("../assets/Index/xinwen9.jpg"),
            content:
              "3月12日，山东能源临矿集团株柏煤矿组织各部门青年志愿者开展了“战疫情，绿动青春”活动，分批次、分区域对矿区树木进行了修建、加固，为改善生态环境、建设绿色矿山献出自己的一份力量。",
            Date: "2020-03-12"
          },
          {
            Title: "同栽一片绿 共享一片蓝",
            src: require("../assets/Index/xinwen10.jpg"),
            content:
              "山东能源枣矿集团铁运处把握好植树节有利时机，提前制定栽种绿化方案，重点对尹洼、孙岗站区进行补种美化，栽植樱花、石楠、红豆杉、女贞、红枫、冬青球等200余株、黄杨400余米4000余棵，绿化面积近2000平方米，勾勒出四季常青、移步异景的温馨生态画卷。",
            Date: "2020-03-12"
          },
          {
            Title: "矿区处处绿意浓",
            src: require("../assets/Index/xinwen11.jpg"),
            content:
              "3月11日，山东能源淄矿集团亭南煤业公司团委组织开展了“守护绿水青山共建亭煤家园”植树活动，11名青年志愿者为中塬风井栽植补种国槐、松树50余棵。",
            Date: "2020-03-11"
          },
          {
            Title: "手指操为职工思想卸压",
            src: require("../assets/Index/xinwen12.jpg"),
            content:
              "进入3月份，山东能源淄矿集团新河矿业公司女工委组织协管员利用基层工区班前会时间，带领职工学练“手指操”，让职工利用工作之余解压，及时调整思想状态，消除在疫情防控期间出现的“厌战”情绪。图为3月5日准备工区职工跟随音乐伴奏学练手指操。",
            Date: "2020-03-10"
          }
        ]
      ],
      list2: [
        [
          {
            src: require("../assets/staff/10.jpg"),
            Title: "“红星”志愿者烈士墓前寻初心"
          },
          {
            src: require("../assets/staff/11.jpg"),
            Title: "书香飘逸迎“三八妇女节”"
          },
          {
            src: require("../assets/staff/12.jpg"),
            Title: "战“疫”有我“青”力而为"
          },
          { src: require("../assets/staff/13.jpg"), Title: "班前会现场开" },
          {
            src: require("../assets/staff/14.jpg"),
            Title: "青春战“疫”亮出“志愿红”"
          },
          {
            src: require("../assets/staff/15.jpg"),
            Title: "严防死守 切断输入性风险源"
          },
          {
            src: require("../assets/staff/16.jpg"),
            Title: "医务人员无偿献血助力抗疫情"
          },
          {
            src: require("../assets/staff/17.jpg"),
            Title: "严防输入风险 拧紧疫情防控阀门"
          },
          {
            src: require("../assets/staff/18.jpg"),
            Title: "热成像测温系统实现就诊人员无接触体温检测"
          }
        ],
        [
          { src: require("../assets/staff/1.jpg"), Title: "有序推进" },
          { src: require("../assets/staff/2.jpg"), Title: "抢修设备" },
          { src: require("../assets/staff/3.jpg"), Title: "快装多运" },
          { src: require("../assets/staff/4.jpg"), Title: "隐患排查" },
          { src: require("../assets/staff/5.jpg"), Title: "精准维修" },
          { src: require("../assets/staff/6.jpg"), Title: "整装待发" },
          { src: require("../assets/staff/7.jpg"), Title: "志愿服务" },
          { src: require("../assets/staff/8.jpg"), Title: "检修维护" },
          { src: require("../assets/staff/9.jpg"), Title: "按章操作" }
        ]
      ]
    };
  },
  components: {
    Head,
    Foot,
    Login
  },
  mounted() {
    this.id = this.$route.query.xiabiao;
    this.j = this.$route.query.news;
    // console.log(this.j)
  },
  methods: {
    isLoginOpen(e) {
      this.isLogin = e;
    }
  }
};
</script>

<style lang="less" scoped>
#NotDel {
  width: 100%;
  min-width: 1000px;
  position: relative;
  .main {
    width: 80%;
    padding: 0 1rem .2rem;
    margin: 0 auto;
    min-height: 100vh;
    margin-top: 0.3rem;
    border: 1px solid #ececec;
    position: relative;
    img {
      max-width: 80%;
      margin: 0 auto;
      display: block;
    }
    > p:not(:first-child) {
      font-size: 0.22rem;
      text-indent: 2em;
      padding-bottom: 0.2rem;
    }
    > p:first-child {
      font-size: 0.35rem;
      font-weight: bold;
      text-align: center;
      margin: 1rem 0 0.5rem 0;
      border-bottom: 1px solid #ccc;
      padding-bottom: 0.3rem;
    }
    .container {
      padding: 0.3rem 0.5rem;
      line-height: 2.4em;
      // font-weight: 400;
      // font-size:.18rem ;
    }
    > p:nth-of-type(2) {
      height: 0.5rem;
      line-height: 0.5rem;
      background: #f4f9fd;
      text-align: center;
      font-size: 0.18rem;
      color: #666666;
      margin-top: 0.2rem;
      margin-bottom: 0.6rem;
    }
    div {
      width: 100%;
      border: 1px dashed #ddd;
      background: #f0f6fb;
      margin-top: 0.7rem;
      padding: 0.1rem 0;
      font-size: 0.18rem;
      text-indent: 2em;
      p {
        line-height: 1.5;
      }
      p:nth-of-type(1) {
        margin-bottom: 0.1rem;
      }
    }
    // > p:last-child {
    //   color: #ccc;
    //   position: absolute;
    //   bottom: 1rem;
    //   right: 2rem;
    // }
  }
}
</style>

